import { processRequest } from "@api/config";
import { messengerAPI } from "@api/messenger";

import { useAuthQuery } from "@lib/queryClient";

import { API_PREFIXES, QUERY_KEYS } from "@configs/api";

export const useGetAllCategoriesUsersQuery = () =>
	useAuthQuery({
		queryKey: [QUERY_KEYS.ALL_CATEGORIES_USERS],
		queryFn: async () => {
			const data = await processRequest({
				prefix: API_PREFIXES.GET_ALL_CATEGORIES_USERS,
				request: (token) => messengerAPI.getAllCategoriesUsersAsync({ token }),
			});
			return data;
		},
	});
